/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
import type { SkeletonProps } from './types';
export { default as Skeleton } from './skeleton';
/** @deprecated use SkeletonProps instead. To be removed in future versions.*/
export type SkeletonPropsT = SkeletonProps;